export default __webpack_public_path__ + "static/media/illustration-square.7688ec3a.svg";